import { render, staticRenderFns } from "./proy-sedes.vue?vue&type=template&id=dd1fb3f4"
import script from "./proy-sedes.vue?vue&type=script&lang=js"
export * from "./proy-sedes.vue?vue&type=script&lang=js"
import style0 from "./proy-sedes.vue?vue&type=style&index=0&id=dd1fb3f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports